import React from 'react';
import propTypes from 'prop-types';
import { Checkout } from '../Checkout';
import { StoreHours } from './StoreHours';
import { productPropTypes } from '../productPropTypes';

const StoreInformation = ({ storeDetails, product, product2 }) => (
  <div className="cmp-store-information">
    <h2 className="cmp-store-information__store-name">
      <span className="cmp-store-information__name-prefix">
        Quote Based on the Following Store:
      </span>
      {storeDetails.name}
    </h2>
    <div className="cmp-store-information__address">
      <a href={`tel:${storeDetails.phone}`} aria-label={storeDetails.phoneAccessible} className="cmp-store-information__phone">
        {storeDetails.phoneVisual}
      </a>
      <address className="cmp-store-information__store-address">
        <p>
          {storeDetails.address.line1}
          <br />
          {storeDetails.address.city}
          ,
          {' '}
          {storeDetails.address.region}
          {' '}
          {storeDetails.address.postalCode}
        </p>
      </address>
    </div>
    <div className="cmp-store-information__store-hours">
      <h3>Store Hours</h3>
      <StoreHours hours={storeDetails.hours} />
    </div>
    <div className="cmp-store-information__checkout">
      <Checkout product={product} product2={product2} />
    </div>
  </div>
);

StoreInformation.propTypes = {
  storeDetails: propTypes.shape({
    number: propTypes.string,
    name: propTypes.string,
    phone: propTypes.string,
    phoneVisual: propTypes.string,
    phoneAccessible: propTypes.string,
    storeLink: propTypes.string,
    distanceMiles: propTypes.number,
    pricingGroup: propTypes.string,
    yelpUrl: propTypes.string,
    facebookUrl: propTypes.string,
    state: propTypes.string,
    address: propTypes.shape({
      postalCode: propTypes.string,
      region: propTypes.string,
      city: propTypes.string,
      line1: propTypes.string,
    }),
    hours: propTypes.shape({
      saturday: propTypes.shape({
        openIntervals: propTypes.arrayOf(
          propTypes.shape({
            start: propTypes.string,
            end: propTypes.string,
          }),
        ),
        isClosed: propTypes.bool,
      }),
      sunday: propTypes.shape({
        openIntervals: propTypes.arrayOf(
          propTypes.shape({
            start: propTypes.string,
            end: propTypes.string,
          }),
        ),
        isClosed: propTypes.bool,
      }),
    }),
  }),
  product: productPropTypes,
  product2: productPropTypes,
};

export { StoreInformation };
